import { STORAGE_PREFIX } from '../config'

export const storage = {
  getToken: () => {
    return JSON.parse(
      window.localStorage.getItem(`${STORAGE_PREFIX}_token`) as string
    )
  },
  setToken: (token: string) => {
    window.localStorage.setItem(
      `${STORAGE_PREFIX}_token`,
      JSON.stringify(token)
    )
  },
  clearToken: () => {
    window.localStorage.removeItem(`${STORAGE_PREFIX}_token`)
    storage.clearProductLineId()
  },
  getProductLineId: () =>
    window.localStorage.getItem(`${STORAGE_PREFIX}_productLineId`) as string,

  setProductLineId: (productLineId: string) => {
    window.localStorage.setItem(
      `${STORAGE_PREFIX}_productLineId`,
      productLineId
    )
  },
  clearProductLineId: () => {
    window.localStorage.removeItem(`${STORAGE_PREFIX}_productLineId`)
  },
  getUserId: () => {
    const userId = window.localStorage.getItem(`${STORAGE_PREFIX}_userId`)
    return userId || null
  },
  setUserId: (userId: string) => {
    if (userId) {
      window.localStorage.setItem(`${STORAGE_PREFIX}_userId`, userId)
    }
  },
  clearUserId: () => {
    window.localStorage.removeItem(`${STORAGE_PREFIX}_userId`)
  }
}

export default storage
